import React from "react";
import loadable from "@loadable/component";

export default {
	component: loadable(() => import("./ContractorMainV4"),{
		fallback: <div>Loading...</div>
	})
};
